/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import _ from 'lodash';
import Modal from '/client/src/components/Modal';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { GET, POST, PUT } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';
import NProgressCustom from '/client/src/components/nProgress';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import Photos from './modalForms/Photos';
import Text from './modalForms/Text';
import SoundCloud from './modalForms/SoundCloud';
import Video from './modalForms/Video';
import MapModal from './modalForms/Map';
import { convertTextLinksToTargetBlank } from '/client/src/utils/string';
import { validateVideoUrl } from '../utils';

import '../styles.scss';
import Events from './modalForms/Events';


type PropsType = {
  isOpen: boolean,
  handleShowModal: (boolean) => void,
  eventDetail: any,
  theme: string,
  eventId: string | number,
  parts: [],
  upPartsData: () => void,
  editablePart?: {
    id: number,
    type: string
  }
};

class EventPageTicketPreviewCustomizeModal extends React.Component<PropsType> {
  props: PropsType;

  static contextType = DefaultContainerContext;
  constructor(props: PropsType) {
    super(props);

    const tabs = [
      {
        label: 'Photos',
        class: 'photo'
      },
      {
        label: 'Text',
        class: 'text'
      },
      {
        label: 'SoundCloud',
        class: 'audio'
      },
      {
        label: 'Video',
        class: 'video'
      },
      {
        label: 'Other Event List',
        class: 'event'
      },
      {
        label: 'Map',
        class: 'map'
      }
    ];

    this.tabs = tabs;
    const editablePartTabIndex = props.editablePart && tabs.findIndex(x => x.class === props.editablePart.type.toLocaleLowerCase());

    this.state = {
      activeTab: editablePartTabIndex || 0,
      isLocked: false,
      isSubmited: false,
      photos: {
        files: _.get(props, 'editablePart.photos', []),
        link_label: _.get(props, 'editablePart.link_label', 'Photos'),
        addToNav: _.get(props, 'editablePart.addToNav', true),
        background_color: _.get(props, 'editablePart.background_color', 'Light')
      },
      text: {
        link_label: _.get(props, 'editablePart.link_label', 'Text'),
        addToNav: _.get(props, 'editablePart.addToNav', true),
        background_color: _.get(props, 'editablePart.background_color', 'Light'),
        text: _.get(props, 'editablePart.text', '')
      },
      soundCloud: {
        link_label: _.get(props, 'editablePart.link_label', 'SoundCloud'),
        addToNav: _.get(props, 'editablePart.addToNav', true),
        background_color: _.get(props, 'editablePart.background_color', 'Light'),
        audio: _.get(props, 'editablePart.audio', [])
      },
      video: {
        link_label: _.get(props, 'editablePart.link_label', 'Video'),
        addToNav: _.get(props, 'editablePart.addToNav', true),
        background_color: _.get(props, 'editablePart.background_color', 'Light'),
        urls: _.get(props, 'editablePart.videos', [])
      },
      events: {
        link_label: _.get(props, 'editablePart.link_label', 'Events'),
        addToNav: _.get(props, 'editablePart.addToNav', true),
        background_color: _.get(props, 'editablePart.background_color', 'Light'),
        ids: _.get(props, 'editablePart.events', [])
      },
      map: {
        link_label: _.get(props, 'editablePart.link_label', 'Map'),
        addToNav: _.get(props, 'editablePart.addToNav', true),
        background_color: _.get(props, 'editablePart.background_color', 'Light'),
        address: _.get(props, 'editablePart.address', props.eventDetail.location),
        lat: _.get(props, 'editablePart.lat', props.eventDetail.lat),
        lng: _.get(props, 'editablePart.lng', props.eventDetail.lng),
        map_zoom: _.get(props, 'editablePart.map_zoom', 9)
      }
    };
  }

  handleTab = (index: number) => {
    this.setState({
      activeTab: index
    });
  };

  handleClose = (): any => {
    const { handleShowModal } = this.props;

    handleShowModal(false);
  };

  handleChangePhotos = (data: any) => {
    this.setState({
      photos: {
        ...this.state.photos,
        ...data
      }
    });
  };

  handleChangeText = (data: string) => {
    this.setState({
      text: {
        ...this.state.text,
        ...data
      }
    });
  };

  handleChangeSC = (data: any) => {
    this.setState({
      soundCloud: {
        ...this.state.soundCloud,
        ...data
      }
    });
  };

  handleChangeVideo = (data: any) => {
    this.setState({
      video: {
        ...this.state.video,
        ...data
      }
    });
  };

  handleChangeEvent = (data: any) => {
    this.setState({
      events: {
        ...this.state.events,
        ...data
      }
    });
  };

  handleChangeMap = async (data: any) => {
    this.setState({
      map: {
        ...this.state.map,
        ...data
      }
    });
  };

  isError = (errors?: any) => {
    CssPinner(document.body, false);
    NProgressCustom(false);

    this.context.handleShowSystemDialog(true, {
      systemDialogType: 'error',
      systemDialogTitle: 'Error!',
      systemDialogContent: !errors ?
        'Can\'t save event' :
        _.map(errors, (er: {}): string => `${er.message}\n\n`)
    });
  };

  isSuccess = () => {
    this.context.handleShowSystemDialog(true, {
      systemDialogType: 'success',
      systemDialogTitle: 'Great!',
      systemDialogContent: 'Successfully'
    });

    setTimeout(() => {
      this.context.handleShowSystemDialog(false);

      CssPinner(document.body, false);
      NProgressCustom(false);
    }, 4000);
  };

  setLoading = (setStatus: () => void) => {
    CssPinner(document.body, true);
    NProgressCustom(true);

    this.setState({
      isLocked: true
    }, () => {
      setStatus('loading');
    });
  }

  toggleSubmit = () => {
    this.setState((prevState) => ({
      isSubmited: !prevState.isSubmited
    }));
  }

  handlePartValidationError = (err: string) => {
    this.context.handleShowSystemDialog(true, {
      systemDialogType: 'error',
      systemDialogTitle: 'Error!',
      systemDialogContent: err
    });
  }

  generateTextLengthValidationMessage = (): any => {
    if (this.state.text.text.length < 5096) {
      return null;
    }
    return [{ message: `The following errors were detected during
    validation. - The field Text must be a string
    with a maximum length of 7500. - The field
    Text must be a string with a maximum length
    of 7500.` }];
  }

  handleSaveMap = async (setStatus: () => void): void => {
    const { editablePart } = this.props;
    const { address, lat, lng } = this.state.map;

    if (!address || !lat || !lng) {
      this.handlePartValidationError('Please enter valid address');
      return false;
    }
    this.setLoading(setStatus);

    try {
      const { result } = editablePart ?
      await PUT(`/api/v1/1/splashpages/${this.props.eventId}/map/${editablePart.id}`, {
        background_color: this.state.map.background_color,
        id: editablePart.id,
        link_label: this.state.map.link_label || 'Map',
        address: this.state.map.address,
        lat: this.state.map.lat,
        lng: this.state.map.lng,
        map_zoom: this.state.map.map_zoom,
        placement_index: 7,
        show_link: true,
        type: 'Map'
      })
      :
      await POST(`/api/v1/1/splashpages/${this.props.eventId}/map`, {
        background_color: this.state.map.background_color,
        id: 0,
        link_label: this.state.map.link_label || 'Map',
        address: this.state.map.address,
        lat: this.state.map.lat,
        lng: this.state.map.lng,
        map_zoom: this.state.map.map_zoom,
        placement_index: this.props.parts.length + 1,
        show_link: true,
        type: 'Map'
      });

      const _parts = this.props.parts;

      if (editablePart) {
        const editedIndex = _parts.findIndex(x => x.id === editablePart.id && x.link_label === editablePart.link_label);

        _parts[editedIndex] = { ..._parts[editedIndex], ...this.state.map };
      } else {
        _parts.push({ ...result });
      }

      this.props.upPartsData(_parts);

      this.setState({
        isLocked: false
      }, () => {
        setStatus('success');
        this.handleClose();
      });

      this.isSuccess();
    } catch (errors) {
      console.log(errors);
      console.error('Can\'t save map');

      this.setState({
        isLocked: false
      }, () => {
        setStatus('error');
      });

      this.isError(errors);
    }
  };

  handleSaveEvent = async (setStatus: () => void): void => {
    const { editablePart } = this.props;
    const eventInput = document.querySelector('#input-add-event-url');

    if (eventInput.value.length > 0) {
      try {
        CssPinner(document.body, true);
        const { result } = await GET(`/api/v1/1/events/${eventInput.value}`);

        if (this.props.eventId === result.id) {
          CssPinner(document.body, false);
          this.context.handleShowSystemDialog(true, {
            systemDialogType: 'error',
            systemDialogTitle: 'Oops',
            systemDialogContent: 'Cannot add current event!'
          });
          return;
        }

        if (_.findIndex(this.state.events.ids, (i) => i.event_id === result.id) !== -1) {
          CssPinner(document.body, false);
          this.context.handleShowSystemDialog(true, {
            systemDialogType: 'error',
            systemDialogTitle: 'Oops',
            systemDialogContent: 'Cannot add same event twice!'
          });
          return;
        }

        this.handleChangeEvent({
          ids: [
            ...this.state.events.ids,
            {
              event_id: result.id,
              placement_index: this.state.events.ids.length + 1
            }
          ]
        });

        CssPinner(document.body, false);
      } catch (e) {
        CssPinner(document.body, false);
        this.context.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Oops',
          systemDialogContent: 'Sparxo Event URL is invalid!'
        });

        return false;
      }
    }

    if (!_.size(this.state.events.ids)) {
      this.handlePartValidationError('Please enter event URL');
      return false;
    }

    this.setLoading(setStatus);

    try {
      const { result } = editablePart ?
      await PUT(`/api/v1/1/splashpages/${this.props.eventId}/event/${editablePart.id}`, {
        background_color: this.state.events.background_color,
        id: editablePart.id,
        link_label: this.state.events.link_label || 'Other Event List',
        events: this.state.events.ids,
        placement_index: editablePart.placement_index,
        show_link: true,
        type: 'Event',
        spRegex: {}
      })
      :
       await POST(`/api/v1/1/splashpages/${this.props.eventId}/event`, {
        background_color: this.state.events.background_color,
        id: 0,
        link_label: this.state.events.link_label || 'Other Event List',
        events: this.state.events.ids,
        placement_index: this.props.parts.length + 1,
        show_link: true,
        type: 'Event',
        spRegex: {}
      });

      const _parts = this.props.parts;

      if (editablePart) {
        const editedIndex = _parts.findIndex(x => x.id === editablePart.id && x.link_label === editablePart.link_label);

        _parts[editedIndex] = {
          ..._parts[editedIndex],
          events: this.state.events.ids
        };
      } else {
        _parts.push({ ...result });
      }

      this.props.upPartsData(_parts);

      this.setState({
        isLocked: false
      }, () => {
        setStatus('success');
        this.handleClose();
      });

      this.isSuccess();
    } catch (errors) {
      console.log(errors);
      console.error('Can\'t save video');

      this.setState({
        isLocked: false
      }, () => {
        setStatus('error');
      });

      this.isError(errors);
    }
  };

  handleSaveVideo = async (setStatus: () => void): void => {
    const { editablePart } = this.props;
    const videoInput = document.querySelector('#input-add-video-url');
    const videoAdd = document.querySelector('#button-add-video-player');

    if (videoInput.value.length > 0) {
      if (!validateVideoUrl(videoInput.value)) {
        this.handlePartValidationError('Video URL is invalid!');
        return false;
      }

      await videoAdd.click();
    }

    if (!_.size(this.state.video.videos)) {
      this.handlePartValidationError('No URL was added. Paste a URL to add a player.');
      return false;
    }

    this.setLoading(setStatus);

    try {
      const { result } = editablePart ?
      await PUT(`/api/v1/1/splashpages/${this.props.eventId}/video/${editablePart.id}`, {
        background_color: this.state.video.background_color,
        id: editablePart.id,
        link_label: this.state.video.link_label || 'Video',
        videos: this.state.video.videos,
        placement_index: editablePart.placement_index,
        show_link: true,
        type: 'Video'
      })
      :
      await POST(`/api/v1/1/splashpages/${this.props.eventId}/video`, {
        background_color: this.state.video.background_color,
        id: 0,
        link_label: this.state.video.link_label || 'Video',
        videos: this.state.video.videos,
        placement_index: this.props.parts.length + 1,
        show_link: true,
        type: 'Video'
      });

      const _parts = this.props.parts;

      if (editablePart) {
        const editedIndex = _parts.findIndex(x => x.id === editablePart.id && x.link_label === editablePart.link_label);

        _parts[editedIndex] = { ..._parts[editedIndex], ...this.state.video };
      } else {
        _parts.push({ ...result });
      }


      this.props.upPartsData(_parts);

      this.setState({
        isLocked: false
      }, () => {
        setStatus('success');
        this.handleClose();
      });

      this.isSuccess();
    } catch (errors) {
      console.log(errors);
      console.error('Can\'t save video');

      this.setState({
        isLocked: false
      }, () => {
        setStatus('error');
      });

      this.isError(errors);
    }
  };

  handleSaveSC = async (setStatus: () => void): void => {
    const { editablePart } = this.props;
    const soundInput = document.querySelector('#input-add-sound-url');
    const soundAdd = document.querySelector('#button-add-sound-player');

    if (soundInput.value.length > 0) {
      if (!soundInput.value.startsWith('https://soundcloud.com/')) {
        this.handlePartValidationError('Please enter valid soundcloud link');
        return false;
      }

      await soundAdd.click();
    }

    if (!_.size(this.state.soundCloud.audio)) {
      this.handlePartValidationError('No URL was added. Paste a URL to add a player.');
      return false;
    }

    this.setLoading(setStatus);

    try {
      const { result } = editablePart ?
      await PUT(`/api/v1/1/splashpages/${this.props.eventId}/audio/${editablePart.id}`, {
        background_color: this.state.soundCloud.background_color,
        id: editablePart.id,
        link_label: this.state.soundCloud.link_label || 'Audio',
        audio: this.state.soundCloud.audio,
        placement_index: editablePart.placement_index,
        show_link: true,
        type: 'Audio'
      })
      :
      await POST(`/api/v1/1/splashpages/${this.props.eventId}/audio`, {
        background_color: this.state.soundCloud.background_color,
        id: 0,
        link_label: this.state.soundCloud.link_label || 'Audio',
        audio: this.state.soundCloud.audio,
        placement_index: this.props.parts.length + 1,
        show_link: true,
        type: 'Audio'
      });

      const _parts = this.props.parts;

      if (editablePart) {
        const editedIndex = _parts.findIndex(x => x.id === editablePart.id && x.link_label === editablePart.link_label);

        _parts[editedIndex] = { ..._parts[editedIndex], ...this.state.soundCloud };
      } else {
        _parts.push({ ...result });
      }

      this.props.upPartsData(_parts);

      this.setState({
        isLocked: false
      }, () => {
        setStatus('success');
        this.handleClose();
      });

      this.isSuccess();
    } catch (errors) {
      console.log(errors);
      console.error('Can\'t save text');

      this.setState({
        isLocked: false
      }, () => {
        setStatus('error');
      });

      this.isError(errors);
    }
  };

  handleSaveText = async (setStatus: () => void): void => {
    const { editablePart } = this.props;

    const { text } = this.state;

    if (!_.size(text.text)) {
      this.handlePartValidationError('Please enter text');
      return false;
    }

    const textWithProperLinks = convertTextLinksToTargetBlank(text.text);

    this.setLoading(setStatus);

    const tmp = document.createElement('DIV');

    tmp.innerHTML = textWithProperLinks;

    const innerText = tmp.textContent || tmp.innerText || '';
    // extracting pure text content from html string (react summernote bug)

    if (!_.size(innerText)) {
      this.toggleSubmit();
      return false;
    }

    this.setLoading(setStatus);
    try {
      const { result } = editablePart ?
      await PUT(`/api/v1/1/splashpages/${this.props.eventId}/text/${editablePart.id}`, {
        background_color: this.state.text.background_color,
        id: editablePart.id,
        link_label: this.state.text.link_label || 'Text',
        text: textWithProperLinks,
        placement_index: editablePart.placement_index,
        show_link: true,
        type: 'Text'
      })
      :
      await POST(`/api/v1/1/splashpages/${this.props.eventId}/text`, {
        background_color: this.state.text.background_color,
        id: 0,
        link_label: this.state.text.link_label || 'Text',
        text: textWithProperLinks,
        placement_index: this.props.parts.length + 1,
        show_link: true,
        type: 'Text'
      });

      const _parts = this.props.parts;

      if (editablePart) {
        const editedIndex = _parts.findIndex(x => x.id === editablePart.id && x.link_label === editablePart.link_label);

        _parts[editedIndex] = { ..._parts[editedIndex], ...this.state.text };
      } else {
        _parts.push({ ...result });
      }

      this.props.upPartsData(_parts);

      this.setState({
        isLocked: false
      }, () => {
        setStatus('success');
        this.handleClose();
      });

      this.isSuccess();
    } catch (errors) {
      console.log(errors);
      console.error('Can\'t save text');

      this.setState({
        isLocked: false
      }, () => {
        setStatus('error');
      });
      const textLengthValidationMessage = this.generateTextLengthValidationMessage();

      this.isError(textLengthValidationMessage || errors);
    }
  };

  handleSavePhotos = async (setStatus: () => void): void => {
    const { editablePart } = this.props;
    const { photos } = this.state;

    if (!_.size(photos.files)) {
      this.handlePartValidationError('Please add photo');
      return false;
    }

    this.setLoading(setStatus);

    try {
      const { result } = editablePart ?
      await PUT(`/api/v1/1/splashpages/${this.props.eventId}/photo/${editablePart.id}`, {
        background_color: this.state.photos.background_color,
        id: editablePart.id,
        link_label: this.state.photos.link_label || 'Photos',
        photos: _.map(this.state.photos.files, (f: {}, fi: number): {} => ({
          url: f.url,
          placement_index: fi + 1
        })),
        placement_index: editablePart.placement_index,
        show_link: true,
        type: 'Photo'
      })
      :
       await POST(`/api/v1/1/splashpages/${this.props.eventId}/photo`, {
        background_color: this.state.photos.background_color,
        id: 0,
        link_label: this.state.photos.link_label || 'Photos',
        photos: _.map(this.state.photos.files, (f: {}, fi: number): {} => ({
          url: f.url,
          placement_index: fi + 1
        })),
        placement_index: this.props.parts.length + 1,
        show_link: true,
        type: 'Photo'
      });

      const _parts = this.props.parts;

      if (editablePart) {
        const editedIndex = _parts.findIndex(x => x.id === editablePart.id && x.link_label === editablePart.link_label);

        _parts[editedIndex] = { ..._parts[editedIndex], ...this.state.photos, photos: this.state.photos.files };
      } else {
        _parts.push({ ...result });
      }

      this.props.upPartsData(_parts);

      this.setState({
        isLocked: false
      }, () => {
        setStatus('success');
        this.handleClose();
      });

      this.isSuccess();
    } catch (errors) {
      console.log(errors);
      console.error('Can\'t save photos');

      this.setState({
        isLocked: false
      }, () => {
        setStatus('error');
      });

      this.isError(errors);
    }
  };

  handleSave = async (setStatus: (string) => void) => {
    const { activeTab } = this.state;

    if (this.state.isLocked) {
      return;
    }

    switch (activeTab) {
      case 0:
        await this.handleSavePhotos(setStatus);
        break;
      case 1:
        await this.handleSaveText(setStatus);
        break;
      case 2:
        await this.handleSaveSC(setStatus);
        break;
      case 3:
        await this.handleSaveVideo(setStatus);
        break;
      case 4:
        await this.handleSaveEvent(setStatus);
        break;
      case 5:
        await this.handleSaveMap(setStatus);
        break;
      default:
        // /
    }
  };

  render(): React.Element<'div'> {
    const { activeTab, isSubmited, isLocked } = this.state;
    const { isOpen, editablePart } = this.props;

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
      >
        <div
          className="modal-dialog customModal EventPageTicketPreviewCustomizeModal splash-editor-modal modal-dialog__overflow"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <span>{editablePart ? `Edit ${editablePart.type} section` : 'Add section'}</span>
              </h4>
            </div>

            <div className="modal-body">
              {!editablePart &&
                <header>
                  <ul className='splash-editor-tabs'>
                    {_.map(this.tabs, (tab: {}, tabi: number): React.Element<'li'> => {
                      return (
                        <li
                          key={`EventPageTicketPreviewCustomizeModal-tab-${tabi}`}
                          onClick={() => {
                            this.handleTab(tabi);
                          }}
                          className={`splash-editor-tabs-item ${tabi === activeTab ? 'active' : ''}`}
                        >
                          <a className={tab.class} />
                          <p>{tab.label}</p>
                        </li>
                      );
                    })}
                  </ul>
                </header>
              }
              {activeTab === 0 &&
                <Photos {...this.props} editablePart={this.state.photos} onHandleChangePhotos={this.handleChangePhotos} />
              }

              {activeTab === 1 &&
                <Text
                  {...this.props}
                  editablePart={this.state.text}
                  isSubmited={isSubmited}
                  onHandleChangeText={this.handleChangeText}
                  onHandleSetLocked={(state) => this.setState({ isLocked: state })}
                />
              }

              {activeTab === 2 &&
                <SoundCloud {...this.props} editablePart={this.state.soundCloud} onHandleChangeSC={this.handleChangeSC} />
              }

              {activeTab === 3 &&
                <Video {...this.props} editablePart={this.state.video} onHandleChangeVideo={this.handleChangeVideo} />
              }

              {activeTab === 4 &&
                <Events {...this.props} editablePart={this.state.events} onHandleChangeEvent={this.handleChangeEvent} />
              }

              {activeTab === 5 &&
                <MapModal {...this.props} editablePart={this.state.map} onHandleChangeMap={this.handleChangeMap}  />
              }
            </div>

            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>Cancel</button>
              <span className="custom-pb-container">
                <BtnLoader
                  label='Save'
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    this.handleSave(setStatus);
                  }}
                  disabled={isLocked}
                />
              </span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EventPageTicketPreviewCustomizeModal;
